import React, { useEffect, useRef } from 'react';
// import '../App.css'; // Assuming all CSS is compiled into App.css or you can keep individual CSS files
// import "bootstrap";
import Header from './Header';
import SignUpForm from './SignUpForm';
import Feature from './Feature';
import Story from './Story';
import Footer from './Footer';
import Tab from './Tab';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

function SignUp() {
    const navigate = useNavigate();
    const signUpFormRef = useRef(null);
    useEffect(() => {
        const auth = localStorage.getItem('token');
        if (auth ) {
            navigate('/');
        }
        }, [navigate]);

        const scrollToForm = () => {
            if (signUpFormRef.current) {
                signUpFormRef.current.scrollIntoView({behavior: 'smooth'});
            }
        } 
    return (
        <div className='noSelect'>
            <Header scrollToForm={scrollToForm}/>
            <div ref={signUpFormRef}> {/* Add the ref here */}
                <SignUpForm />
            </div>
            <Feature />
            <Story />
            <Tab />
            <ToastContainer/>
            <Footer />
        </div>
    );
}

export default SignUp;
